<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container" style="width:100% !important">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" v-on:click.prevent="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!-- page content -->
            <div class="admin-page-content">
                <!-- Forms -->
                <div :class="alertClass" id="success-alert">
                    <strong> {{alertMessage}} </strong>
                </div>
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">
                        <!-- Name -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="name" placeholder="Enter Name" v-model="name">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{nameError}}</span>
                            </div>
                        </div>
                        <!-- Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Email : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="email" placeholder="Enter Email" v-model="email">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{emailError}}</span>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                        <!-- Password -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Password : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input id="toggle-password" type="password" placeholder="Enter Password" class="form-control" name="password" v-model="password">
                                <div class="requiredstarPassword">*</div>
                                <span toggle="#toggle-password" class="fa fa-lg fa-eye field-icon toggle-password"></span>
                                <span class="text-danger">{{passwordError}}</span>
                            </div>
                        </div>
                        <!-- Confirm Password -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Confirm Password : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input id="toggle-password-confirm" type="password" class="form-control" name="confirmPassword" placeholder="Confirm Password" v-model="confirmPassword">
                                <div class="requiredstarConfirmPassword">*</div>
                                <span toggle="#toggle-password-confirm" class="fa fa-lg fa-eye field-icon toggle-password-confirm"></span>
                                <span class="text-danger">{{confirmPasswordError}}</span>
                            </div>
                        </div>
                        <template v-if="isNonVVGDealer == 'NO'">
                            <!-- Confirm Password -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Permission : </div>
                                </div>
                                <!-- <div class="col-9 paddingleft0">
                                    <v-select v-model="permission"
                                        name="permission"
                                        id="permission"
                                        label="text"
                                        :filterable="true"
                                        :options="permissionArr"
                                        :clearable=false
                                        @input="onChnagePermission()"
                                        placeholder="Select Permission">
                                    </v-select>
                                </div> -->
                                <div class="col-9 paddingleft0">
                                    <b-form-group>
                                        <b-form-checkbox-group
                                            id="permission"
                                            v-model="permission"
                                            :options="permissionArr"
                                            name="permission"
                                        ></b-form-checkbox-group>
                                    </b-form-group>
                                </div>
                            </div>
                        </template>
                        <!-- Confirm Password -->
                        <div class="col-6 forms-block">
                            <div class="paddingleft">
                                <div class="form-label">Master Customer Access : 
                                    <input class="ml-2" type="checkbox" name="isMasterCustomer" v-model="isMasterCustomer" id="isMasterCustomer">
                                </div>
                            </div>
                        </div>
                        <template v-if="isNonVVGDealer == 'NO'">
                            <div class="col-12 forms-block">
                                <div class="paddingleft0">
                                    <div class="form-label">
                                        <label class="container" style="width 175px; padding: 0px !important;">
                                            <input class="mr-2" type="checkbox" id="1" value="1" v-model="isAllowEnterPO">
                                            Allow to enter PO# number in Mobile Application
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <!-- Error Alert -->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <!-- <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button> -->
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <!-- Buttons -->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary my-1 ms-2" v-on:click.prevent="addUpdateCustomer()">
                        <input id="addAndContinueBenifitBtn" :disabled="disableButtons.saveAndContinue" type="submit" :value="buttonNames.saveAndContinue" class="btn btn-primary my-1 ms-2" v-on:click.prevent="addUpdateCustomer(flag='Save and Continue')">
                        <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary my-1 ms-2" v-on:click.prevent="buttonBack">
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!-- page content -->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    var moment = require('moment-timezone');

    export default {
        name: 'AddUpdateMember',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
        },
        data() {
            return {
                pageTitle : "Add Member",
                isAllowEnterPO: 0,
                name : '',
                nameError : "",
                email : "",
                emailError : "",
                password : "",
                passwordError : "",
                confirmPassword : "",
                confirmPasswordError : "",
                // permissionArr: [
                //     {
                //         text: 'Backend Website',
                //         value: 'backend_website'
                //     },
                //     {
                //         text: 'Mobile Application',
                //         value: 'mobile_application'
                //     },
                //     {
                //         text: 'View Only',
                //         value: 'view_only'
                //     }
                // ],
                // permission: {text: "Mobile Application", value: 'mobile_application'},
                permission: [],
                permissionArr: [],
                buttonNames : {
                    save : 'Save',
                    saveAndContinue : 'Save And Continue',
                    cancel : 'Cancel'
                },
                disableButtons : {
                    save : false,
                    saveAndContinue : false,
                    cancel : false
                },
                alertClass : '',
                alertMessage : '',
                parentCustomerId: 0,
                isMasterCustomer: false,
                isNonVVGDealer: 'NO',
            }
        },
        beforeMount: function() {
            self = this;
            EventBus.$emit("menu-selection-changed", "listCustomer");
        },
        watch: {
            permission: {
                handler: function (val, oldVal) {
                    if (self.permission.includes(3)) {
                        if (self.permission.includes(1)) {
                            let index = self.permission.indexOf(1)
                            if (index > -1) {
                                self.permission.splice(index, 1)
                            }
                        }
                        if (!self.permission.includes(2)) {
                            self.permission.push(2)
                        }
                        if (self.permissionArr.length > 0) {
                            self.permissionArr[0].disabled = true
                            self.permissionArr[1].disabled = true
                        }
                    } else {
                        if (self.permissionArr.length > 0) {
                            self.permissionArr[0].disabled = false
                            self.permissionArr[1].disabled = false
                        }
                    }
                },
                deep: true
            }
        },
        mounted: function() {
            // EventBus.$emit('showHeader', true);
            self.isNonVVGDealer = process.env.NON_VVG_DEALER;
            if(self.isNonVVGDealer == "YES") {
                self.permission = {text: "Backend Website", value: 'backend_website'};
                self.isAllowEnterPO = 0;
            }
            $("#alertError").hide();
            self.getAllPermissions();
            self.getCustomerPermissions();
            self.removeErrorMessageOnInput();
            $(".requiredstarPassword").show();
            $(".requiredstarConfirmPassword").show();

            if(typeof(self.$route.params.memberId)  != 'undefined' && self.$route.params.memberId != 0 && self.$route.params.memberId != '') {
                self.parentCustomerId  = self.$route.params.id;
                $("#addAndContinueBenifitBtn").hide();
                self.buttonNames.save = 'Update';
                self.pageTitle = "Update Member";
                self.getMemberDetailById();
            }
            self.toggelPasswordConfirmPassword();
        },
        beforeDestroy() {
            // EventBus.$off('all-permissions');
        },
        methods: {
            onChnagePermission: function() {
            },
            removeErrorMessageOnInput: function() {
                /* Remove error on input */
                $("#name").keyup(function () {
                    self.nameError = "";
                });
                $("#email").keyup(function () {
                    self.emailError = "";
                });
                $("#toggle-password").keyup(function () {
                    self.passwordError = "";
                });
                $("#toggle-password-confirm").keyup(function () {
                    self.confirmPasswordError = "";
                });
            },
            toggelPasswordConfirmPassword: function() {
                $(".toggle-password").click(function() {
                    $(this).toggleClass("fa-eye fa-eye-slash");
                    var input = $($(this).attr("toggle"));
                    if (input.attr("type") == "password") {
                        input.attr("type", "text");
                    } else {
                        input.attr("type", "password");
                    }
                });
                $(".toggle-password-confirm").click(function() {
                    $(this).toggleClass("fa-eye fa-eye-slash");
                    var input = $($(this).attr("toggle"));
                    if (input.attr("type") == "password") {
                        input.attr("type", "text");
                    } else {
                        input.attr("type", "password");
                    }
                });
            },
            getMemberDetailById: function() {
                var fields = {
                    customer_id: self.$route.params.memberId,
                };
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };
                HTTP.post('/customer-details-by-id', fields, config)
                    .then(response => {
                        self.name = response.data.customer.name;
                        self.email = response.data.customer.email;
                        self.isMasterCustomer = response.data.customer.is_master_customer;
                        self.permission = response.data.customer_permissions;
                        // self.permission = {text: self.formatString(response.data.customer.access.replace("_", " ")), value: response.data.customer.access}; 
                        self.isAllowEnterPO = response.data.customer.is_allow_enter_po;
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },
            showAlertOnSave: function(alertMessage, alertType) {
                if (alertType === "success") {
                    self.alertClass = "alert alert-success";
                } else {
                    self.alertClass = "alert alert-danger";
                }
                self.alertMessage = alertMessage;
                $("#success-alert").fadeTo(3000, 500).slideUp(500, function(){
                    $("#success-alert").slideUp(500);
                });
            },
            buttonBack: function() {
                var custId = localStorage.getItem("parentCustomerId");
                localStorage.removeItem("parentCustomerId");
                self.$router.push('/member/list/' + custId);
            },
            clearDataOnSaveAndContinue: function() {
                self.name = '';
                self.email = "";
                self.password = "";
                self.confirmPassword = "";
                self.permission = {text: "Mobile Application", value: 'mobile_application'};
                self.isMasterCustomer = false;
                self.isAllowEnterPO = 0;
                if(self.isNonVVGDealer == "YES") {
                    self.permission = {text: "Backend Website", value: 'backend_website'};
                    self.isAllowEnterPO = 0;
                }
            },
            checkForm: function() {
                var checked = true;
                var path = window.location.pathname;
                var segments = path.split("/");
                self.nameError = "";
                self.emailError = "";
                self.confirmPasswordError = "";
                self.passwordError = "";

                if (!self.name) {
                    self.nameError = "Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.email) {
                    self.emailError = "Email Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.email && !self.validEmail(self.email)) {
                    self.emailError = "Please Enter Valid Email";
                    if (checked) {
                        checked = false;
                    }
                }
                if(typeof(self.$route.params.memberId)  != 'undefined' && self.$route.params.memberId != 0 && self.$route.params.memberId != '') {
                    if (self.password && !self.confirmPassword) {
                        self.confirmPasswordError = "Confirm Password Required";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.confirmPassword && !self.checkPasswordAndConfirmPassword(self.password, self.confirmPassword)) {
                        self.confirmPasswordError = "Password and Confirm Password do not match";
                        if (checked) {
                            checked = false;
                        }
                    }
                } else {
                    if(!self.password) {
                        self.passwordError = "Password Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (self.password && !self.confirmPassword) {
                        self.confirmPasswordError = "Confirm Password Required";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.confirmPassword && !self.password) {
                        self.passwordError = "Password Required";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.confirmPassword && !self.checkPasswordAndConfirmPassword(self.password, self.confirmPassword)) {
                        self.confirmPasswordError = "Password and Confirm Password do not match";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                return checked;
            },
            checkPasswordAndConfirmPassword: function(password, confirmPassword) {
                if (password != confirmPassword) {
                    return false;
                } else {
                    return true;
                }
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            addUpdateCustomer(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        var config = {
                            headers: {Authorization:localStorage.getItem("access_token")},
                        };
                        if(typeof(self.$route.params.memberId)  != 'undefined' && self.$route.params.memberId != 0 && self.$route.params.memberId != '') {
                            var data = {
                                name: self.name,
                                email: self.email,
                                password : self.password,
                                confirm_password : self.confirmPassword,
                                parent_customer_id : localStorage.getItem("parentCustomerId"),
                                access_permission: self.permission,
                                id: self.$route.params.memberId,
                                is_master_customer: self.isMasterCustomer ? 1 : 0,
                                is_allow_enter_po: self.isAllowEnterPO ? 1 : 0,
                                is_non_vvg_dealer: (self.isNonVVGDealer == 'YES') ? 1 : 0,
                            };
                            self.buttonNames.save = "Updating ...";
                            self.disableButtons.save = true;
                            self.disableButtons.cancel = true;
                        } else {
                            var data = {
                                name: self.name,
                                email: self.email,
                                password : self.password,
                                confirm_password : self.confirmPassword,
                                parent_customer_id : localStorage.getItem("parentCustomerId"),
                                access_permission: self.permission,
                                is_master_customer: self.isMasterCustomer ? 1 : 0,
                                is_allow_enter_po: self.isAllowEnterPO ? 1 : 0,
                                is_non_vvg_dealer: (self.isNonVVGDealer == 'YES') ? 1 : 0,
                            };
                            if (flag == "Save and Continue") {
                                self.buttonNames.saveAndContinue = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true
                            } else {
                                self.buttonNames.save = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true;
                            }
                        }
                        HTTP.post("/add-update-customer", data, config)
                            .then(function (response) {
                                EventBus.$emit('change_sidebar_menu', false, response.data.content);
                                if(typeof(self.$route.params.memberId)  != 'undefined' && self.$route.params.memberId != 0 && self.$route.params.memberId != '') {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    self.buttonNames.save = "Update";
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                    } else {
                                        self.buttonNames.save = "Save";
                                    }
                                }
                                if (response.data.status == "success") {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    EventBus.$emit('succes-message', response.data.user_message);
                                    //self.showAlertOnSave(response.data.user_message, "success");
                                    self.showSAlert(response.data.user_message,'success',false);
                                    if (flag == "Save and Continue") {
                                        self.clearDataOnSaveAndContinue();
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                    } else {
                                        setTimeout(function () {
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    self.disableButtons.save = false;
                                    self.disableButtons.saveAndContinue = false;
                                    self.disableButtons.cancel = false;
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i];
                                        }
                                        EventBus.$emit('succes-message', err);
                                        self.showAlertOnSave(err, "error");
                                    }
                                }
                            })
                            .catch(function (err) {
                                if(typeof(self.$route.params.memberId)  != 'undefined' && self.$route.params.memberId != 0 && self.$route.params.memberId != '') {
                                    self.buttonNames = "Update";
                                    self.disableButtons.save = false;
                                    self.disableButtons.cancel = false;
                                    //self.showAlertOnSave(err.response.data.message, "error");
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                        self.clearDataOnSaveAndContinue();
                                    } else {
                                        self.buttonNames.save = "Save";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }
                                }
                                if (err.response.status == 0) {
                                    self.errorMsg = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                    EventBus.$emit('succes-message', err.response.data.message);
                                    //self.showAlertOnSave(err.response.data.message, "error");
                                }
                            });
                    }
                }, 200);
            },
            getCustomerPermissions () {
                var config = {
                    headers: {
                        Authorization: localStorage.getItem("access_token")
                    }
                };
                HTTP.get("get-customer-permissions", config)
                    .then(function(response) {
                        self.permissionArr = response.data.content
                        if (self.permission.includes(3)) {
                            if (self.permission.includes(1)) {
                                let index = self.permission.indexOf(1)
                                if (index > -1) {
                                    self.permission.splice(index, 1)
                                }
                            }
                            if (!self.permission.includes(2)) {
                                self.permission.push(2)
                            }
                            if (self.permissionArr.length > 0) {
                                self.permissionArr[0].disabled = true
                                self.permissionArr[1].disabled = true
                            }
                        } else {
                            if (self.permissionArr.length > 0) {
                                self.permissionArr[0].disabled = false
                                self.permissionArr[1].disabled = false
                            }
                        }
                    })
                    .catch(function(err) {
                        console.log('catch ', err)
                    });
            }
        }
    }
    EventBus.$on('all-location-list', function (response) {
        if (typeof (self) != 'undefined') {
            self.locationOption = response;
        }
    });
</script>

<style>
    .field-icon {
        float: right;
        margin-right: 8px;
        margin-top: -23px;
        position: relative;
        z-index: 2;
        cursor:pointer;
    }
    .container{
        padding-top:50px;
        margin: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/Customer/AddUpdateMember.vue